<template>
	<div class="bigBox">
		<div class="bigBox-l">
			<div class="bigBox-l-t">
				<el-carousel id="banner" ref="change"  @change="videoChange" trigger="click" :interval="5000" :autoplay="false" arrow="never" height="100%">
					<el-carousel-item v-for="(item,index) in bans" :key="index">
						<div style="width:100%;height:100%;position: relative;background: #ddd;color:#000;" :title="item.title">
								<img v-if="item.photoUrl.split('.')[item.photoUrl.split('.').length-1]!='mp4'" :src="item.photoUrl" style="width:100%;height:100%;" />
								<div v-if="item.photoUrl.split('.')[item.photoUrl.split('.').length-1]=='mp4'" class="videoCont">
									<video :id="item.id" @playing="cleardate" @ended="handlePause" class="videoA" controls="controls" :src="item.photoUrl" style="width:100%;object-fit: fill;height:100%;" />
									<i @click="turnOn(item)" :class="tiemDone==0?'el-icon-video-play':'el-icon-video-pause'"></i>
								</div>
						</div>
					</el-carousel-item>
			</el-carousel>
			</div>
			<div class="bigBox-l-b">
				<div class="title">
					<div class="title-l">学习园地</div>
					<div class="title-r" @click="entervideList">更多</div>
				</div>
				<div class="cont xxx">
					<img @click="down" class="cont-left" src="../../assets/image/left.png" alt="">
					<img @click="up" class="cont-right" src="../../assets/image/right.png" alt="">
					<div class="row">
						<div class="aaa" v-for="item in videoList1">
							<video class="ccc" controls="controls" @onloadeddata="showFrame(event)" style="height:100%;width:100%;object-fit: fill" :src="item.videoUrl"></video>
							<img :src="item.videoCover" class="ddd"></img>
							<p class="eee">{{item.videoName}}</p>
							<p class="qqq">{{item.videoLength}}</p>
						</div>
					</div>
					<div class="row" style="margin-top:2vw">
						<div class="aaa" v-for="item in videoList2">
							<video class="ccc" controls="controls"  style="height:100%;width:100%;object-fit: fill" :src="item.videoUrl"></video>
							<img :src="item.videoCover" class="ddd"></img>
							<p class="eee">{{item.videoName}}</p>
							<p class="qqq">{{item.videoLength}}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="bigBox-r">
			<div class="bigBox-r-t">
				<div class="title">
					<div class="title-l">企业介绍</div>
					<div></div>
				</div>
				<div class="cont1 lpl">
						<!-- <div class="demo-body" style="overflow: hidden;">
                        <div class="box-cont" style="width:100%;height:100%;position: relative;" >
                            <div v-html="html"></div>
                        </div>
                    </div> -->

										<div v-html="html"></div>
					</div>
			</div>
			<div class="bigBox-r-b">
				<!-- <div class="bigBox-r-b-t">
					<div class="title">
					<div class="title-l">安环动态</div>
					<div></div>
				</div>
				<div class="cont1">
						<div class="second-body ">
                        <div class="table-head color1">
                            <p>项目</p>
                            <p>检查人</p>
                            <p>检查事项</p>
                            <p>检查时间</p>
                        </div>
                        <div class="table-head-list">
                            <ul :class="{anim:animate==true}">
                                <li class="table-li" v-for="item in postList" :key="item.id" style="height:4vh;">
                                    <p style="width:25%;">
                                        <span class="nowrapA" style="text-align:left;display: inline-block;width: 100%;" :title="item.projectName">{{item.projectName}}</span>
                                    </p>
                                    <p style="width:25%;">
                                        <span class="nowrapA">{{item.reportName}}</span>
                                    </p>
                                    <p style="width:25%;">
                                        <span class="nowrapA" style="display: inline-block;width: 100%;" :title="item.description">{{item.description}}</span>
                                    </p>
                                    <p style="width:25%;">
                                        <span class="nowrapA">{{item.reportDate}}</span>
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
					</div>
				</div> -->
				<div class="bigBox-r-b-b">
					<div class="title">
					<div class="title-l">安环动态</div>
					<div></div>
				</div>
				<div class="cont1" @mouseover="hoverStop" @mouseleave="hoverStart">
					<div class="demo-body" style="overflow: auto;">
                        <ul class="demo-ul" :class="{anim:animate3==true}">
                            <li class="table-li" v-for="item in lawsList" :key="item.id" style="height:4vh;align-content: center;align-items: center;">
                                <i class="el-icon-caret-right" style="color:#2061BE;font-size:12px"></i>
                                <p class="name" @click="toInfo(item,2)"><span style="width:100%;display:inline-block;text-align: left;font-size:12px" class="nowrap" :title="item.title">{{item.title}}</span></p>
                                <p class="dec" @click="toInfo(item,2)"><span style="width:100%;display:inline-block;text-align: left;font-size:12px" class="nowrap" :title="item.content">{{item.content}}</span></p>
                                <p class="time" style="font-size:12px">{{item.time}}</p>
                            </li>
                        </ul>
                    </div>
				</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import HighCharts from 'highcharts'
	import myHttp from '../../untils/port'
	import util from '../../untils/util'
	import base from '../../untils/base'
	export default {
		data() {
			return {
				bans:[
					// {id:1,url:require('../../assets/image/ban1.png')}
				],
				groupId:'',
				tiemDone:0,
				stop:true,
				tiem:null,
				html:'',
				postList:[  //项目巡查
                // {id:'1',name:'****项目',label:'*****事项',csSum:'达标'}
            ],
				animate:false, //滚动
				animate3:false,
				lawsList:[],
				groupType:'',
				videoList: [],
				videoList1: [],
				videoList2: [],
				port:'',
				pageSize:6,
				pageNum:1,
				pages:1,
                timer3:''
			}
		},
		mounted(){
			this.groupId = util.session.get('groupId')
			if (util.session.get('roleId') == '3') {
      this.groupType = '3'
    } else if (this.$store.state.roleId == '4') {
      this.groupType = '1'
    } else if (util.session.get('roleId') == '5') {
      this.groupType = '2'
    }
		this.port = util.session.get('roleId') //4.项目端 5。企业端
			this.getBanner()
			 if(this.timer1){
            window.clearInterval(this.timer1)
        }
        if(this.timer2){
            window.clearInterval(this.timer2)
        }
        if(this.timer3){
            window.clearInterval(this.timer3)
        }
        if(this.timer4){
            window.clearInterval(this.timer4)
        }
				this.tiem = setTimeout(() => {
            this.$refs.change.next()
            document.querySelector('.videoA').controls=false
        }, 4000);
        // 鼠标移入轮播停止
        document.querySelector('#banner').onmouseover=()=>{
            document.querySelectorAll('.el-icon-video-pause').forEach((item,index)=>{
                item.style.display='block'
            })
            this.stop = false
            console.log(this.tiem,'停止')
            if(this.tiem!=null){
                clearInterval(this.tiem)
                if(this.tiemDone==1){
                    document.querySelectorAll('.videoA').forEach(item=>{
                        item.controls=true
                    })
                }else{
                    document.querySelectorAll('.videoA').forEach(item=>{
                        item.controls=false
                    })
                }
            }
        }
        document.querySelector('#banner').onmouseout=()=>{
            this.stop = true
            document.querySelector('.videoA').controls=false
            if(this.tiemDone==1){
                document.querySelectorAll('.el-icon-video-pause').forEach((item,index)=>{
                    console.log(item)
                item.style.display='none'
            })
            }else{
                this.tiem = setTimeout(() => {
            this.$refs.change.next()
            console.log('开始')
            
        }, 4000);
            }
        }
				if(this.groupId && ''!=this.groupId){
            //获取出勤
            // this.getAttend()
            // this.getCai()
            // this.edcData()
            // this.getProNum()
            // this.getProjectList()
            this.getNotice()
            // this.getBanner()
            this.getQs()
            //获取弹出框数据
            // this.getProWorker()
            // this.getProPerson()
            // this.getProTotal()
						this.getInfoByIdNew()
				this.getData()
        }
		},
		methods:{
            hoverStop(){
                console.log('停止')
                if(this.timer3!=''){
                    window.clearInterval(this.timer3)
                    this.timer3=''
                }
            },
            hoverStart(){
                this.timer3 = setInterval(this.scroll3,1800)
            },
            playVido(){
                console.log('111')
                let list = document.querySelectorAll('.ccc')
                list.forEach((item,index)=>{
                    item.addEventListener('play',function(){
                         console.log("开始播放");
                         item.nextSibling.style.opacity = 0
                    })
                    item.addEventListener('pause',function(){
                         
                         item.nextSibling.style.opacity = 1
                    })
                    item.addEventListener('ended',function(){
                        
                         item.nextSibling.style.opacity = 1
                    })
                })
            },
            toInfo(row,type){
            // if(type==1){
            //     this.$store.commit('setFirstMenu', 'noticeEnt')
            // }else{
            //     this.$store.commit('setFirstMenu', 'laws')
            // }
            this.$router.push({name:'noticeDetails1',params:{id:row.id,type:type}})
        },
			up(){
				if(this.pageNum>this.pages-1){
					return
				}else{
                    this.pageNum++
				this.videoList1=[]
				this.videoList2=[]
				this.getData()
                }
				
			},
			down(){
				if(this.pageNum==1){
					return
				}else{
                    this.pageNum--
				this.videoList1=[]
				this.videoList2=[]
				this.getData()
                }
				
			},
			showFrame(event) {
			let scale = 0.8
			video = event.target
			console.log(video)
			canvas = document.createElement("canvas"); // 创建一个画布
			canvas.width = video.videoWidth * scale;
			canvas.height = video.videoHeight * scale;
			canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height); 
			
	
			
				console.log("Error: " + err);
			
		},
			entervideList(){
				this.$router.push('/courseEnt')
			},
			getData() {
      var that = this
      if(this.port==5||this.port==3){
          myHttp
        .getVideoEnt({
          entId: this.groupId,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        })
        .then(function (resp) {
          console.log(resp)
          if (resp.data.code == '200') {
            var list = resp.data.data.pageInfo.list || []
            for (var i = 0; i < list.length; i++) {
              list[i].videoCover =
                list[i].videoCover && list[i].videoCover != ''
                  ? base.httpCtx + list[i].videoCover
                  : require('../../assets/image/v-cover.png')
              list[i].videoUrl =
                list[i].videoUrl && list[i].videoUrl != ''
                  ? base.httpCtx + list[i].videoUrl
                  : ''
            }
            that.videoList = list
						that.pages = resp.data.data.pageInfo.pages
						console.log(that.videoList)
						if(list.length>0){
				list.forEach((item,index)=>{
					if(index<=2){
						that.videoList1.push(item)
					}else{
						that.videoList2.push(item)
					}
				})
                
                setTimeout(() => {
                    that.playVido()
                }, 2000);
			}
          }
        })
      }else {
       myHttp.projectExamVideoProjectList({
          projectId: this.groupId,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        })
        .then(function (resp) {
          //console.log(resp)
          if (resp.data.code == '200') {
            var list = resp.data.data.examVideoProjectList.list || []
            for (var i = 0; i < list.length; i++) {
              list[i].videoCover =
                list[i].videoCover && list[i].videoCover != ''
                  ? base.httpCtx + list[i].videoCover
                  : require('../../assets/image/v-cover.png')
              list[i].videoUrl =
                list[i].videoUrl && list[i].videoUrl != ''
                  ? base.httpCtx + list[i].videoUrl
                  : ''
            }
            that.videoList = list
						that.pages = resp.data.data.pageInfo.pages
						if(list.length>0){
				list.forEach((item,index)=>{
					if(index<=3){
						that.videoList1.push(item)
					}else{
						that.videoList2.push(item)
					}
					console.log(that.videoList1,that.videoList2)
				})
			}
          }
        })
      }
			
    },
			getNotice(){
            var that = this
						myHttp.pageInfoNo({
							entId:this.groupId,
							pageSize:20,
							pageNum:1,
							type:3,
							joinType:this.groupType
						}).then(
							function (resp) {
								console.log(resp)
								if (resp.data.code == '200') {
									var list2 = resp.data.data.list || []
									for(var j=0;j<list2.length;j++){
                        list2[j].time = list2[j].createDate.split(' ')[0]
                    }
									that.lawsList = list2
                                    
									that.timer3 = setInterval(that.scroll3,1800)
								} else {
									
								}
							},
							function () {}
						)
        },
				scroll3(){
            if(this.lawsList.length>7){
                var that = this
                this.animate3=true;    // 因为在消息向上滚动的时候需要添加css3过渡动画，所以这里需要设置true
                setTimeout(()=>{      //  这里直接使用了es6的箭头函数，省去了处理this指向偏移问题，代码也比之前简化了很多
                        this.lawsList.push(this.lawsList[0]);  // 将数组的第一个元素添加到数组的
                        this.lawsList.shift();               //删除数组的第一个元素 attendTeam   
                        this.animate3 = false;  // margin-top 为0 的时候取消过渡动画，实现无缝滚动
                },1000)
            }else{
                window.clearInterval(this.timer3)
                this.timer3=''
            }
        },
			scroll1(){
            if(this.postList.length>3){
                var that = this
                this.animate=true;    // 因为在消息向上滚动的时候需要添加css3过渡动画，所以这里需要设置true
                setTimeout(()=>{      //  这里直接使用了es6的箭头函数，省去了处理this指向偏移问题，代码也比之前简化了很多
                        this.postList.push(this.postList[0]);  // 将数组的第一个元素添加到数组的
                        this.postList.shift();               //删除数组的第一个元素 attendTeam   
                        this.animate = false;  // margin-top 为0 的时候取消过渡动画，实现无缝滚动
                },1000)
            }else{
                window.clearInterval(this.timer1)
            }
        },
			//获取项目巡查
        getQs(){
            var that = this
            myHttp.getQsListByEntIdAndJoinType({
                entId:this.groupId,
                type:'2',
                // startTime:util.myTime.getCurMonth()+'-01',
                // endTime:util.myTime.getCurMonth()+'-'+util.myTime.getMonthDay(),
                flag:'5',
                joinType:'',
                pageNum:'1',
                pageSize:'10',
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.qsList.list||[]
                    for(var i=0;i<list.length;i++){
                        list[i].reportDate = list[i].reportDate?list[i].reportDate.split(' ')[0]:''
                    }
                    that.postList = list
                    that.timer1 = setInterval(that.scroll1,2000) // 合同滚动
                }
            })
        },
			getInfoByIdNew(){
        myHttp.getInfoByIdNew({
          id:util.session.get('groupId'),
        }).then(res=>{
          console.log(res)
          if(res.data.code==200){
            this.html= res.data.data.enterprise.entDesc
          }
          
        })
      },
			turnOn(item){
            if(this.tiemDone!=1){
                this.tiemDone=1
                document.getElementById(item.id).play()
            }else{
                this.tiemDone=0
                document.getElementById(item.id).pause()
            }
        },
			handlePause(){
            document.querySelectorAll('.el-icon-video-pause').forEach((item,index)=>{
                item.style.display='block'
            })
            document.querySelectorAll('.videoA').forEach(item=>{
                item.controls=false
                this.tiemDone=0
                
            })
            this.tiem = setTimeout(() => {
            this.$refs.change.next()
        }, 4000);
        },
			cleardate(){
            clearInterval(this.tiem)
        },
			videoChange(){
             document.querySelectorAll('.videoA').forEach(item=>{
                item.controls=false
            })
            document.querySelectorAll('.videoA').forEach(item=>{
                item.pause()
                this.tiemDone=0
            })
           if(this.stop){
             console.log('shipinbofangla')
            clearInterval(this.tiem)
            this.tiem = setInterval(() => {
            this.$refs.change.next()
        }, 4000);
            // console.log(document.querySelectorAll('.videoA'))
            // document.getElementsByClassName('.movie').pause()
           }
        },
			getBanner(){
				var that = this
					myHttp.getBannerEnt({
							entId:this.groupId,
							joinType:''
					}).then(function(resp){
							if(resp.data.code=='200'){
									var list = resp.data.data||[]
									for(var i=0;i<list.length;i++){
											list[i].photoUrl = list[i].photoUrl && list[i].photoUrl!=''?base.httpCtx+list[i].photoUrl:''
									}
									if(list.length==0){
											list.push( {id:1,photoUrl:require('../../assets/image/ban1.png'),title:''})
									}
									that.bans = list
									console.log(that.bans)
							}else{
									that.bans = [{id:1,photoUrl:require('../../assets/image/ban1.png'),title:''}]
							}
					})
			},
		}
	}
</script>

<style scoped>
.xxx{
	position: relative;
    height: calc(100% - 5vh);
}
.cont-left{
	position:absolute;
	left: -0.3vw;
	top: 37%;
	width: 2.6042vw;
	height: 2.6042vw;
}
.cont-right{
	position:absolute;
	top: 37%;
	right: 0.2vw;
	width: 2.6042vw;
	height: 2.6042vw;
}
.cont-right:hover{
	opacity: 0.7;
	cursor: pointer;
}

.cont-left:hover{
	opacity: 0.7;
	cursor: pointer;
}
.qqq{
	position: absolute;
	left: .1563vw;
	bottom: .1563vw;
	font-size: .625vw;
	color: #fff;
	z-index: 101;
}
.eee{
	position:absolute;
	left: 0;
	bottom: -1.2vw;
    font-size: .625vw;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.aaa:hover .ddd {
	display: none;
	
}
.aaa:hover .qqq {
	display: none;
	
}
.ddd{
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	position: absolute;
	z-index: 100;
}
.bigBox{
	width: 100%;
	height: 100%;
	background-color: #ECF0F5;
	padding: 1.0417vw;
	display: flex;
	justify-content: space-between;
}
.bigBox-l{
	width: 55.2083vw;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}
.bigBox-r{
	width: calc(100% - 55.2083vw - 1.0417vw);
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}
.bigBox-l-t{
	height: 47vh;
	background-color: #fff;
}
.bigBox-l-b{
	height: calc(100% - 47vh - 1.0417vw);
	background-color: #fff;
}
.aaa{
	height: 9vh;
	/* background-color: #f00; */
	width: calc(100% / 3 - 6vw);
	box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.2);
	margin-right: 5vw;
	position: relative;
}
.aaa:nth-child(3){
	margin-right: 0;
}
.aaa:nth-child(1){
	margin-left: 3.8vw;
}
.title{
	height: 5vh;
	padding-left: 1.4063vw;
	padding-right: .8333vw;
	display: flex;
	align-items: center;
	justify-content: space-between;
}
.title-l{
	font-size: 1.0417vw;
font-weight: normal;
letter-spacing: 0em;
color: #666666;
position: relative;
}
.title-r{
	font-size: 14px;
font-weight: normal;
letter-spacing: 0em;
color: #358ADA;
}
.title-r:hover{
	cursor: pointer;


	opacity: 0.7;
}
.title-l::before{
	content: "";
	position:absolute;
	left: -0.4167vw;
	top: 0;
	height: 100%;
	width: .1563vw
	;

	background-color: #2566C0;
}
.anim{
        transition: all 1s;
        margin-top: -4vh;
    }
.row{
	display: flex;
	width: 100%;
}
.cont{
	padding: 0 1.875vw;
}
.bigBox-r-t{
	height: 43vh;
	background-color: #fff;
}
.bigBox-r-b{
	height: calc(100% - 43vh - 1.0417vw);
	display: flex;
	justify-content: space-between;
	flex-direction: column;
}
.bigBox-r-b-t{
	height: calc(100% / 2 - .5208vw);
	background-color: #fff;
}
.bigBox-r-b-b{
	/* height: calc(100% / 2 - .5208vw); */

    height: 100%;
	background-color: #fff;
}
::v-deep .el-carousel__button{
    width: 10px;
height: 10px;
border-radius: 21px;
background: #8A949D;
}

::v-deep .el-carousel__indicator.is-active button{
    opacity: 1;
    width: 30px;
height: 10px;
border-radius: 21px;
background: #EBEADC;
}
.videoCont{
		position: relative;
		width:100%;height:100%;
}
.videoCont>i{
		position: absolute;
		left: 45%;
top: 42%;
font-size: 4vw;
cursor: pointer;
color: #fff;
    }
.cont1{
	padding: 0 .8333vw;
	height: calc(100% - 5vh);
	overflow: auto;
}
.second-body{
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        padding: 0 1.5vh ;
        flex-wrap: wrap;
        /* overflow: hidden; */
    }
.table-head{
        width: 100%;
        height: 3vh;
        position: relative;
        display: flex;
        background-color: #F7F7F7;
    }
.table-head p{
        width: 33%;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        justify-items: center;
        align-content: center;
        align-items: center;
        font-family: MicrosoftYaHei;
font-size: 12px;
font-weight: normal;
line-height: 11px;
letter-spacing: 0px;
color: #999999;
    }
.table-head-list{
        width: 100%;
        height: calc( 100% - 3.1vh );
        position: relative;
        overflow: hidden;

    }
    .table-li{
        width: 100%;
        height: 4vh;
        position: relative;
        display: flex;
    }
    .table-li p{
        width: 33%;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        justify-items: center;
        align-content: center;
        align-items: center;
    }
.nowrapA{
        white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-family: MicrosoftYaHei;
font-size: 12px;
font-weight: normal;
line-height: 11px;
letter-spacing: 0px;
color: #797979;
}
.demo-body{
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        flex-wrap: wrap;
        padding-top: 1vh;
    }
    .demo-body .img-item{
        width: 100%;
        height: 15vh;
        position: relative;
        padding: 0.5vh;
        display: flex;
    }
    /* .demo-body .img-item  */
    .demo-ul{
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
    }
    .demo-ul .time{
        width: 16vh;
    }
    .demo-ul .name{
        flex: 1;
        padding-left:0.5vh;
        cursor: pointer;
    }
    .demo-ul .dec{
        width: 25vh;
        cursor: pointer;
    }

    .lpl{
        text-align: start;
    }
    .lpl span{
        text-align: left !important;
    }
    .lpl font{
        text-align: left !important;
    }
</style>















<style>
.el-carousel{
     width: 100%;
     height: 100%;
 }
</style>